import { FC } from 'react'
import { useTranslation } from 'react-i18next';
import {
    Link
} from "react-router-dom";
import Breadcrumb from '../../Components/Breadcrumb';
import TemplateForm from './form';


const TemplateCreate: FC = () => {  
    const { t } = useTranslation();
    return ( 
        <> 
            <Breadcrumb />

            <div className="container-fluid">

                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title">
                                    { t('Ajouter un template') }
                                </h4>
                                <Link type="button" to="/template/list"
                                    className="btn waves-effect waves-light btn-primary">
                                        { t('Liste des templates') }
                                </Link>
                                <br />
                                <br />

                                <TemplateForm state='create' template={null} />  
                                 
                                </div>
                            </div> 
                    </div> 
                </div>

            </div>   
        </>                   
    );
}

export default TemplateCreate